export default {
  DIALOG_OPEN_MUTATION(state, type) {
    state.dialogs.push(type);
  },
  DIALOG_CLOSE_MUTATION(state, type) {
    state.dialogs = state.dialogs.filter(v => v !== type);
  }
};
